import {Component, OnDestroy, OnInit} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {ColumnApi, ExcelStyle, GridApi, GridOptions} from 'ag-grid-community';
import AppConstants, {
  agency_user,
  agency_admin_role,
  system_admin
} from '../../../shared/common-components/AppConstants';
import {User} from '../../../services/user/user';
import {UserService} from '../../../services/user/user.service';
import {AlertService} from '../../../services/alert/alert.service';
import {takeWhile} from 'rxjs/operators';
import _ from 'lodash';
import {Router} from '@angular/router';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {IffShipmentDetailsService} from 'src/app/services/iff-shipment-details/iff-shipment-details.service';
import {Subscription, BehaviorSubject} from 'rxjs';
import { formatDate } from '@angular/common';
import * as Constants from '../../../shared/common-components/AppConstants';
import {CommonHelpers} from '../../../shared/common-helpers';
import { CarrierService } from 'src/app/services/carrier/carrier.service';
import {fakeAsync} from "@angular/core/testing";
import {IffShipmentSummaryService} from "../../../services/iff-shipment-summary/iff-shipment-summary.service";

@Component({
    selector: 'app-hhg-comprehensive-report',
    templateUrl: './hhg-comprehensive-report.component.html',
    styleUrls: ['./hhg-comprehensive-report.component.css'],
    standalone: false
})
export class HhgComprehensiveReportComponent implements OnInit, OnDestroy {
  agency_auditor = Constants.agency_auditor_role;
  agency_admin = Constants.agency_admin_role;
  agency_user = Constants.agency_user;
  carrier_user = Constants.carrier_user;
  carrier_user_admin = Constants.carrier_user_admin;
  carrier_user_RF = Constants.carrier_user_RF;
  system_admin = Constants.system_admin;

  currentUser: User | any;
  private observer$ = new BehaviorSubject(true);
  hhgComprehensiveFormGroup: FormGroup;
  resultsSubscription = new Subscription();
  // setHeight: number;
  public reportingYrList = [];
  reportingYr: number;
  reportingQtr = 0;
  currrentYr = 0;

  isRfsp: Boolean;
  rfspCarrierList: any[];
  rfspScacList: any[];
  rfspCarrierId: number;
  selectedCarrierId: number;
  carrierEntity: any;
  selectedTsp: any;

  gridOptions: GridOptions = {
    rowSelection: 'multiple',
    defaultColDef: {
      sortable: true,
      resizable: true,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: false
      }
    },
    pagination: true,
    paginationPageSize: 10,
    cacheBlockSize: 25,
    headerHeight: 50,
    domLayout: 'autoHeight',
    suppressDragLeaveHidesColumns: true,
    getRowHeight: () => 35,

    overlayLoadingTemplate:
      '<span class="ag-overlay-loading-center">Select the Reporting Year/Quarter to load report.</span>',
    overlayNoRowsTemplate:
      '<span>No results found. Please adjust your filters.</span>'
  };
  format = 'MM/dd/yyyy';
  locale = 'en-US';
  private gridApi: GridApi;
  public gridColumnApi;
  subArr = [];
  columnsDefs: any;
  rowData: any;
  rowData1: any;

  hhgComprensivecolumnDefs = [
    {
      headerName: 'SCAC',
      field: 'scac',
      filter: 'agTextColumnFilter', sortable: true,
      width: 120
    },
    {
      headerName: 'TSP Name',
      field: 'scacName',
      filter: 'agTextColumnFilter', sortable: true
    },
    // '<a tabindex="0">' + params.data.totalIFF + '</a>';
    {
      headerName: 'Shipment Report Contact Name',
      valueGetter: (params) => {
        return (params.data.firstName || params.data.lastName || params.data.email) ?
                  (params.data.firstName + ' ' + params.data.lastName) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Shipment Report Contact Email',
      valueGetter: (params) => {
        return (params.data.email) ?
                  (params.data.email) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'FAIC',
      field: 'faicCode',
      width: 150,
      filter: 'agTextColumnFilter', sortable: true,
      cellClass: 'textFormat'
    },
    {
      headerName: 'SRO Code',
      field: 'sroCode',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Point of Contact',
      valueGetter: params => {
        return params.data.pofContact ? params.data.pofContact : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Agency Name',
      field: 'agencyName',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Bureau Name',
      field: 'agencyBureauName',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Pro Bill Number',
      field: 'proBillNumber',
      filter: 'agTextColumnFilter',
      cellClass: 'textFormat',
      sortable: true
    },
    {
      headerName: 'BOL',
      field: 'bolNumber',
      filter: 'agTextColumnFilter',
      sortable: true,
      cellClass: 'textFormat'
    },
    {
      headerName: 'GBL/CBL',
      field: 'gblcbl',
      width: 100,
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Move Type',
      field: 'moveType',
      width: 110,
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Transportation Type',
      field: 'transportationType',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Pickup Date',
      valueGetter: (params) => {
        return params.data.pickupDate ? (formatDate(params.data.pickupDate , this.format, this.locale)) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Delivery Date',
      valueGetter: (params) => {
        return params.data.deliveryDate ? (formatDate(params.data.deliveryDate , this.format, this.locale)) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Transit Time',
      field: 'transitTime',
      filter: 'agTextColumnFilter', sortable: true, comparator: this.iffShipmentSummaryService.numberComparator
    },
    {
      headerName: 'Billing Date',
      valueGetter: (params) => {
        return params.data.billingDate ? (formatDate(params.data.billingDate , this.format, this.locale)) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Origin',
      field: 'originStateCode',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Destination',
      field: 'destinationStateCode',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Employee Last Name',
      field: 'employeeLastName',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Weight',
      field: 'weight',
      width: 100,
      filter: 'agTextColumnFilter', sortable: true, comparator: this.iffShipmentSummaryService.numberComparator
    },
    {
      headerName: 'Miles',
      field: 'miles',
      width: 100,
      filter: 'agTextColumnFilter', sortable: true, comparator: this.iffShipmentSummaryService.numberComparator
    },
    {
      headerName: 'Discount',
      field: 'discount',
      width: 110,
      filter: 'agTextColumnFilter', sortable: true, comparator: this.iffShipmentSummaryService.numberComparator
    },
    {
      headerName: 'Gross Amount',
      field: 'grossAmount',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.currencyComparator
    },
    {
      headerName: 'Net Amount',
      field: 'netAmount',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.currencyComparator
    },
    {
      headerName: 'Pass Thru Amt',
      field: 'passThruAmount',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.currencyComparator
    },
    {
      headerName: 'Reporting Year',
      field: 'reportingYear',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Reporting Quarter',
      field: 'reportingQuarter',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Employee Email Identifier',
      field: 'employeeEmail',
      filter: 'agTextColumnFilter', sortable: true
    }
  ];
  iffAmountCol = {
    headerName: 'Total AF',
    field: 'totalIFF',
    filter: 'agTextColumnFilter',
    sortable: true,
    comparator: this.iffShipmentSummaryService.currencyComparator
  };
  excelStyles: ExcelStyle[] = [
    {
       id: 'textFormat',
       dataType: 'String',
     }
   ];

  /**
   * @description defines the button renderer component to show the smartWay button based on the flag.
   */
  constructor(private userService: UserService, private alertService: AlertService, private shipmentDetailService: IffShipmentDetailsService,
    private fb: FormBuilder,
    private router: Router, private loader: LoadingService,
    private carrierService: CarrierService,
    private iffShipmentSummaryService: IffShipmentSummaryService) {

  }

   /**
   * initializing the ag-grid
   * @param params
   */
  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
    this.gridApi = params.api;
     this.gridColumnApi = params.columnApi;
  }

   /**
   * @description manipulates row data according to the desired results and generates columns dynamically by looping through rowData.
   */
  ngOnInit() {
    this.hhgComprehensiveFormGroup = this.fb.group({
      tspListSelect: new FormControl(''),
      reportingYrSelect: new FormControl('', Validators.required),
      reportingQtrSelect: new FormControl('', [Validators.required, Validators.min(0), Validators.max(4)])

    });
    this.currrentYr = new Date().getFullYear();
    this.reportingYrList.push({name: this.currrentYr, value: this.currrentYr});
    for (let i = 1; i < 7; i++) {
      const previousYr = this.currrentYr - i;
      this.reportingYrList.push({name: previousYr, value: previousYr});
    }
    // this.getHHGCompresensiveDetails(this.currrentYr, this.currrentQr);
    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(currentUser => {
        this.currentUser = currentUser;
        if (this.currentUser.carrierId) {
          this.loadTspsForRfsp();
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.info('unable to get current user details');
      });

  }
  onShipmentReportStatusClicked(){
    this.router.navigate(['/tspHhgShpmntRptStatus']);
  }
  getHHGCompresensiveDetails(){
    if (this.isRfsp){
     this.getHHGCompresensiveDetailsforRfsp();
    }else{
     this. getHHGCompresensiveDetailsforAllOthers();
    }
   }
   getHHGCompresensiveDetailsforAllOthers() {
    this.loader.show();
    this.resultsSubscription = this.shipmentDetailService.getHHGComprehensiveReport(this.reportingYr, this.reportingQtr).subscribe(res => {
      if (res !== null && res !== undefined && res.length > 0) {
        this.rowData = CommonHelpers.sortAtoZ(res);
        this.columnsDefs = this.hhgComprensivecolumnDefs;
        if (!this.checkUserRole(agency_user) && !this.checkUserRole(agency_admin_role)) {
          this.columnsDefs.splice((this.columnsDefs.length - 3), 0, this.iffAmountCol);
        }
        this.loader.hide();
      } else {
        this.rowData = null;
        this.loader.hide();
      }
    });
  }

  getHHGCompresensiveDetailsforRfsp(){
    this.loader.show();
    this.resultsSubscription = this.shipmentDetailService.getHHGComprehensiveReportforRfsp(this.reportingYr, this.reportingQtr,'HHG',this.selectedCarrierId).subscribe(res => {
          if (res !== null && res !== undefined && res.length > 0) {
            this.rowData = CommonHelpers.sortAtoZ(res);
            this.columnsDefs = this.hhgComprensivecolumnDefs;
            if (!this.checkUserRole(agency_user) && !this.checkUserRole(agency_admin_role)) {
              this.columnsDefs.splice((this.columnsDefs.length - 3), 0, this.iffAmountCol);
            }
            this.loader.hide();
          } else {
            this.rowData = null;
            this.loader.hide();
          }
    });
  }

  onReportYrChange(reportYr: number) {
    this.reportingYr = reportYr;
  }
  onReportQtrChange(reportQtr: number) {
    this.reportingQtr = reportQtr;
    console.log(this.hhgComprehensiveFormGroup);
  }
  /**
   *
   * @param: roles
   * @returns: {boolean}
   */
  checkUserRole(roles?) {
    return CommonHelpers.checkUserRoles(this.currentUser, roles);
  }

  loadTspsForRfsp(){
    console.log("sy load tsp rfsp");
    this.carrierService.getCarrierByCarrierId(this.currentUser.carrierId).subscribe(carrier => {
    this.carrierEntity = carrier;
    this.isRfsp = this.carrierEntity.carrierType === 'RFSP';
    this.isRfsp ? this.rfspCarrierId = this.carrierEntity.carrierId : this.rfspCarrierId = 0;
    console.log("rsfp carrier id:" + this.rfspCarrierId);
    if(this.isRfsp){
      this.carrierService.getAllRfspsCarriersIff(this.carrierEntity.carrierId).subscribe(
             result => {
               this.rfspCarrierList = result;
               this.rfspCarrierList.sort((a,b) => a.scac > b.scac ? 1 : -1);
               console.log(this.rfspCarrierList);
               this.rfspScacList = this.rfspCarrierList.map(s => s.scac);
               console.log(this.rfspScacList);
             }, error => {
              this.alertService.error('Error while getting rfsp tsp list');
              }
            );
          }
        });

  }

  tspChange(event:any){
        this.selectedTsp = this.hhgComprehensiveFormGroup.get('tspListSelect').value;
        console.log(this.selectedTsp);
        let tsp = this.rfspCarrierList.filter(r => r.scac === this.selectedTsp);
        this.selectedCarrierId = tsp[0].carrierId;
        console.log(this.selectedCarrierId);
  }
  getRowHeight(params) {
    return (params.data.firstName || params.data.lastName || params.data.email) ? 50 : 25;
  }

  /**
   * @description exports all the grid data from the datasource into a csv file using ag-grid api
   */
  // onBtExport() {
  //   const date = new Date();
  //   const params = {
  //     fileName: 'hhg-comprehensive-report-' + date + '.csv',
  //     columnSeparator: ','
  //   };
  //   this.gridApi.exportDataAsCsv(params);
  // }

  ngOnDestroy(): void {
    this.resultsSubscription.unsubscribe();
  }
}
